import styled from 'styled-components';

export const PageWrapper = styled.div`
  min-height: 100vh;
  max-width: 1080px;
  margin: 0 auto;
  padding: 3rem 2rem;
  background: var(--bg-main);
  color: var(--text-main);

  @media (max-width: 768px) {
    padding: 2rem 1.25rem;
  }
`;

export const BackRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.5rem;
`;

export const HeroToolbar = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  flex-wrap: wrap;
`;

export const HeroCard = styled.section`
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid var(--border-color);
  background: var(--bg-card);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
`;

export const HeroCover = styled.div`
  width: 100%;
  min-height: 360px;
  background: ${props => props.image ? `url(${props.image})` : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'};
  background-size: cover;
  background-position: center;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
      to top,
      rgba(0, 0, 0, 0.72) 0%,
      rgba(0, 0, 0, 0.2) 45%,
      rgba(0, 0, 0, 0) 100%
    );
  }
`;

export const HeroContent = styled.div`
  position: absolute;
  left: 1.25rem;
  right: 1.25rem;
  bottom: 1.25rem;
  z-index: 2;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 1rem;
`;

export const HeroTitleBlock = styled.div`
  h1 {
    margin: 0;
    color: #fff;
    font-size: clamp(1.8rem, 2.8vw, 2.6rem);
    line-height: 1.1;
    font-weight: 800;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
  }
`;

export const ContentStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const Panel = styled.section`
  border: 1px solid var(--border-color);
  background: var(--bg-card);
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  @media (max-width: 768px) {
    padding: 1.5rem;
  }
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1.25rem;
`;

export const PanelTitle = styled.h3`
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  letter-spacing: -0.01em;
`;

export const AddChipButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  border: 1.5px dashed var(--primary-color);
  background: transparent;
  color: var(--primary-color);
  font-weight: 600;
  font-size: 0.85rem;
  padding: 0.4rem 0.9rem;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    background: var(--primary-color);
    color: #fff;
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(88, 166, 255, 0.25);
  }

  i {
    font-size: 0.75rem;
  }
`;

export const DescriptionText = styled.p`
  margin: 0;
  color: var(--text-main);
  line-height: 1.65;
  white-space: pre-wrap;
`;

export const ChipsWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
`;

export const LinksList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
`;

export const LinkRow = styled.a`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  text-decoration: none;
  color: var(--text-main);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  padding: 0.75rem 0.85rem;
  transition: border-color 0.2s ease, transform 0.2s ease;

  &:hover {
    border-color: var(--primary-color);
    transform: translateY(-1px);
  }

  .left {
    display: inline-flex;
    align-items: center;
    gap: 0.6rem;
    min-width: 0;
  }

  .title {
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const ScreenshotsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
  gap: 1.25rem;
`;

export const ScreenshotCard = styled.div`
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid var(--border-color);
  background: var(--bg-card);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  }
`;

export const ScreenshotLink = styled.a`
  display: block;
`;

export const ScreenshotImage = styled.img`
  display: block;
  width: 100%;
  height: 145px;
  object-fit: cover;
`;

export const ScreenshotDeleteButton = styled.button`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  ${ScreenshotCard}:hover & {
    opacity: 1;
  }

  &:hover {
    background: #e5484d;
    transform: scale(1.1);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  i {
    font-size: 0.75rem;
  }
`;

export const EmptyMessage = styled.div`
  border: 1px dashed var(--border-color);
  border-radius: 12px;
  padding: 1.5rem;
  color: var(--text-secondary);
  text-align: center;
`;

export const NotFoundBox = styled.div`
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NotFoundCard = styled.div`
  border: 1px solid var(--border-color);
  background: var(--bg-card);
  border-radius: 14px;
  padding: 2rem;
  text-align: center;
  max-width: 420px;

  h3 {
    margin: 0 0 0.75rem 0;
  }

  p {
    margin: 0 0 1.2rem 0;
    color: var(--text-secondary);
  }
`;
